export default "__VITE_ASSET__D6QZzQ72__"